import React from "react"
import { Redirect } from "react-router-dom"
import { URL_PATHS } from "constants/index"
import {
  checkPermission,
  userIsGodMode,
  userIsCorporate,
  isMpClient,
  isEncapptureClient,
} from "utils"

import Login from "containers/Authentication/Login"
import Logout from "containers/Authentication/Logout"
import ForgetPwd from "containers/Authentication/ForgetPassword"
import ResetPwd from "containers/Authentication/ResetPassword"

import LandingScreen from "containers/AppSetup_LandingScreen"
import ListScreen from "containers/AppSetup_ListScreen"
import ContactUs from "containers/AppSetup_ContactUs"
import Popup from "containers/Popup"
import Experiences from "containers/Experiences"
import Contacts from "containers/People"
import Communications from "containers/Communications"
import BookingCalendar from "containers/BookingCalendar"
import EventsCalendar from "containers/EventsCalendar"
import Profile from "containers/Profile"
import UserAdministration from "containers/UserAdministration"
import PlatformSettings from "containers/PlatformSettings"
import Domains from "containers/Domains"
import Domain from "containers/Domains/domainScreen"
import BusinessUnits from "containers/BusinessUnits"

import Dashboard from "containers/Dashboard/index"

import PagesMaintenance from "containers/UtilityPages/pages-maintenance"
import PagesComingsoon from "containers/UtilityPages/pages-comingsoon"
import Pages404 from "containers/UtilityPages/pages-404"
import Pages500 from "containers/UtilityPages/pages-500"
import AppSetupOnboarding from "containers/AppSetup_Onboarding"
import Categories from "containers/Categories"
import ExperienceForm from "containers/Experiences/ExperienceForm"
import NotificationForm from "containers/Communications/Notifications/notificationForm"
import CustomEmailForm from "containers/Communications/CustomEmails/customEmailForm"
import EditCommunication from "containers/Communications/editCommunication"

import Clients from "containers/ClientList/index"
import ClientForm from "containers/ClientList/clientForm"
import ClientFeatures from "containers/ClientList/ClientFeatures/index"
import Tags from "containers/Tags/index"
import Places from "containers/Places"
import VisitorRegistration from "containers/Visitors"
import AddOnModules from "containers/AddOnModules"
import PlacesForm from "containers/Places/placesForm"
import Surveys from "containers/Places/surveys"
import CategoryForm from "containers/Categories/categoryForm"
import ProductsAndSubscriptions from "containers/ProductsAndSubscriptions"
import SiteUsers from "containers/SiteUsers"
import AdminRoles from "containers/AdminRoleManagement/Roles"
import Permissions from "containers/AdminRoleManagement/Permissions"
import CancelledBookingScreen from "containers/BookingCalendar/cancelledBookingScreen"
import SuccessBookingScreen from "containers/BookingCalendar/successBookingScreen"
import Codes from "containers/Codes"
import GenerateCodeScreen from "containers/Codes/generateCodeScreen"
import OrderDetails from "containers/ProductsAndSubscriptions/Orders/orderDetails"
import EventReports from "containers/Analytics/Event_Reports"
import PollReports from "containers/Analytics/Polls"
import SurveyResports from "containers/Analytics/Surveys"
import PollList from "containers/Analytics/Polls/pollList"
import SurveyList from "containers/Analytics/Surveys/surveyList"
import FormBuilderList from "containers/Analytics/FormBuilders/formBuilderList"
import QuestionnaireList from "containers/Analytics/Questionnaires/questionnaireList"
import triviaList from "containers/Analytics/Trivias/triviaList"
import eventInfoList from "containers/Analytics/EventInfo/eventInfoList"
import linkList from "containers/Analytics/Links/linkList"
import FormBuilderReports from "containers/Analytics/FormBuilders/index"
import QuestionnaireReports from "containers/Analytics/Questionnaires/index"
import TriviaReports from "containers/Analytics/Trivias/index"
import bookingPayments from "containers/Analytics/Payment_Reports/bookingPayments"
import formPayments from "containers/Analytics/Payment_Reports/formPayments"
import EventInfoReport from "containers/Analytics/EventInfo"
import basicContentList from "containers/Analytics/BasicContent/basicContentList"
import BasicContent from "containers/Analytics/BasicContent"
import documentList from "containers/Analytics/Documents/documentList"
import Documents from "containers/Analytics/Documents"
import commentBoardList from "containers/Analytics/CommentBoard/commentBoardList"
import CommentBoard from "containers/Analytics/CommentBoard"
import countdownClockList from "containers/Analytics/CountdownClock/countdownClockList"
import CountdownClock from "containers/Analytics/CountdownClock"
import mediaGalleryList from "containers/Analytics/MediaGallery/mediaGalleryList"
import MediaGallery from "containers/Analytics/MediaGallery"
import Bookings from "containers/Analytics/Bookings"
import Camera from "containers/Analytics/Camera"
import Leaderboard from "containers/Analytics/Leaderboard"
import PrivateMessage from "containers/Analytics/PrivateMessage"
import ReferFriend from "containers/Analytics/ReferFriend"
import AttendeeList from "containers/Analytics/AttendeeList"
import Links from "containers/Analytics/Links"
import Calendars from "containers/Analytics/Calendars"
import listOfLists from "containers/Analytics/Lists/listOfLists"
import Lists from "containers/Analytics/Lists"
import listItem from "containers/Analytics/Lists/listItem"
import TicketPeak from "containers/TicketPeak"
import { isWesternEdgeClient } from "utils"
import SubCalendarReports from "containers/Analytics/Bookings/subCalendarReports"
import UserReports from "containers/Analytics/Bookings/userReports"
import bookingData from "containers/Analytics/Bookings/bookingData"
import FlaggedContent from "containers/MenuFeatures/MediaGallery/flaggedContent"
import IfoOrderForm from "containers/ProductsAndSubscriptions/Orders/IFO_orderForm"
import OrderConfirmation from "containers/ProductsAndSubscriptions/Orders/orderConfirmation"
import harvard_orderForm from "containers/ProductsAndSubscriptions/Orders/harvard_orderForm"
import NewsFeed from "containers/NewsFeed"
import Inbox from "containers/Inbox"
import TagsForm from "containers/Tags/tagsForm"
import Two_FA from "containers/Authentication/Two_FA"
import default_form from "containers/ProductsAndSubscriptions/Orders/default_form"

import AxisCare from "containers/AxisCare"

const MENU_GROUPS = {
  APP_SETUP: {
    display: "App Screen Setup",
    icon: "bx bx-mobile-alt",
    key: "APP_SETUP",
  },
}

/**
 * routes properties definitions:
 * path {@type: string, defined in URL_PATHS constants}: the URL path where the page will be available
 * component: the component rendered on UI for the path
 * menuGroup:{@type: string, defined on the MENU_GROUPS constant}, if mentioned, the route will be displayed on a menu group in the sidebar
 * display {@type: string}: sidebar entry name
 * icon {@type: string}: sidebar entry icon
 * showOnMenu {@type: boolean}: true if the route should be displayed on the sidebar
 * userHasAccess {@type: boolean}: true if the user should have access to the rendered page; if false, the user will see a 404 Not found page at that route
 */

const checkClientConfig = (clientConfig = {}, property, value = 1) => {
  if (typeof property !== "string") {
    return false
  }

  if (typeof clientConfig !== "object" || clientConfig === null) {
    return false
  }

  return clientConfig[property] === value
}

const checkFeatureAvailability = (featuresAvailable = [], feature) => {
  if (!Array.isArray(featuresAvailable)) {
    return false
  }

  if (typeof feature !== "string" || feature.trim() === "") {
    return false
  }

  return featuresAvailable.indexOf(feature) !== -1
}

export const getUserRoutes = (clientConfig = {}, featuresAvailable = []) => [
  {
    path: "/dashboard",
    component: Dashboard,
    display: "Dashboard",
    icon: "bx bx-home-circle",
    showOnMenu: true,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.TICKETPEAK,
    display: "Ticketing",
    icon: "bx bx-credit-card-alt",
    component: TicketPeak,
    showOnMenu: isWesternEdgeClient() || isEncapptureClient(),
    userHasAccess: isWesternEdgeClient() || isEncapptureClient(),
  },

  //HEADER links
  {
    path: URL_PATHS.PROFILE,
    component: Profile,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: `${URL_PATHS.PROFILE}/:userId`,
    component: Profile,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.USER_ADMINISTRATION,
    component: UserAdministration,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.PLATFORM_SETTINGS,
    component: PlatformSettings,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.BUSINESS_UNITS,
    component: BusinessUnits,
    display: "Business Units",
    icon: "bx bxs-business",
    showOnMenu: false,
    userHasAccess:
      checkPermission("manage_business_units") &&
      (userIsGodMode() || userIsCorporate()),
  },
  {
    path: URL_PATHS.TAGS,
    component: Tags,
    display: "Tags",
    icon: "bx bx-purchase-tag",
    showOnMenu: false,
    userHasAccess: checkPermission("manage_meta_tags"),
  },

  {
    path: URL_PATHS.CREATE_TAG,
    component: TagsForm,
    showOnMenu: false,
    userHasAccess: checkPermission("manage_meta_tags"),
  },

  {
    path: URL_PATHS.EDIT_TAG,
    component: TagsForm,
    showOnMenu: false,
    userHasAccess: checkPermission("manage_meta_tags"),
  },

  // {
  //   path: URL_PATHS.ONBOARDING_FLOW,
  //   component: AppSetupOnboarding,
  //   showOnMenu: false,
  //   userHasAccess: checkPermission("manage_onboarding_screens"),
  // },
  {
    path: URL_PATHS.SETUP_LANDING_PAGE,
    component: LandingScreen,
    showOnMenu: false,
    userHasAccess:
      checkClientConfig(clientConfig, "landing_page") &&
      checkPermission("manage_landing_page"),
  },
  {
    path: URL_PATHS.SETUP_LIST_SCREEN,
    component: ListScreen,
    showOnMenu: false,
    userHasAccess: checkPermission("manage_list_screen"),
  },
  {
    path: URL_PATHS.SETUP_CONTACT_US,
    component: ContactUs,
    showOnMenu: false,
    userHasAccess:
      checkClientConfig(clientConfig, "contact_us") &&
      checkPermission("manage_contact_us_list"),
  },

  //SIDERBAR items

  {
    path: URL_PATHS.CONTACTS,
    component: Contacts,
    display: "Users",
    icon: "bx bx-user",
    showOnMenu: checkPermission("view_users"),
    userHasAccess: checkPermission("view_users"),
  },
  {
    path: URL_PATHS.EXPERIENCES,
    component: Experiences,
    display: "Experiences",
    icon: "bx bx-star",
    showOnMenu:
      checkClientConfig(clientConfig, "manage_events") ||
      checkPermission("view_events"),
    userHasAccess:
      checkClientConfig(clientConfig, "manage_events") ||
      checkPermission("view_events"),
  },
  {
    path: URL_PATHS.COMMUNICATIONS,
    component: Communications,
    display: "Communications",
    icon: "bx bx-chat",
    showOnMenu: checkPermission("manage_communications"),
    userHasAccess: checkPermission("manage_communications"),
  },
  {
    path: URL_PATHS.BOOKING_CALENDAR,
    component: BookingCalendar,
    display: "Booking",
    icon: "bx bx-calendar",
    showOnMenu:
      checkPermission("manage_bookings") &&
      (checkFeatureAvailability(featuresAvailable, "show_bookings") ||
        checkFeatureAvailability(featuresAvailable, "booking_service")),
    userHasAccess:
      checkPermission("manage_bookings") &&
      (checkFeatureAvailability(featuresAvailable, "show_bookings") ||
        checkFeatureAvailability(featuresAvailable, "booking_service")),
  },
  // {
  //   path: URL_PATHS.EVENTS_CALENDAR,
  //   component: EventsCalendar,
  //   display: "Event Module", //"Events Calendar",
  //   icon: "bx bx-calendar-event",
  //   showOnMenu:
  //     checkPermission("manage_calendars") &&
  //     checkFeatureAvailability("calendar"),
  //   userHasAccess:
  //     checkPermission("manage_calendars") &&
  //     checkFeatureAvailability("calendar"),
  // },
  {
    path: URL_PATHS.CODES,
    component: Codes,
    display: "Codes",
    icon: "bx bx-barcode",
    showOnMenu: isMpClient() && checkPermission("manage_invitebandz_codes"),
    userHasAccess: isMpClient() && checkPermission("manage_invitebandz_codes"),
  },
  {
    path: URL_PATHS.POPUP,
    component: Popup,
    display: "Pop Up Ad Module",
    icon: "bx bx-message-alt-check",
    showOnMenu:
      checkClientConfig(clientConfig, "ads_enabled") &&
      checkPermission("manage_ads"),
    userHasAccess:
      checkClientConfig(clientConfig, "ads_enabled") &&
      checkPermission("manage_ads"),
  },
  {
    path: URL_PATHS.PLACES,
    component: Places,
    display: "Places",
    icon: "bx bx-map",
    showOnMenu: checkFeatureAvailability(featuresAvailable, "places"),
    userHasAccess: checkFeatureAvailability(featuresAvailable, "places"),
  },
  {
    path: URL_PATHS.VISITORS,
    component: VisitorRegistration,
    display: "Visitor Registration",
    icon: "bx bxs-layer-plus",
    showOnMenu: checkFeatureAvailability(featuresAvailable, "register_guest"),
    userHasAccess: checkFeatureAvailability(
      featuresAvailable,
      "register_guest"
    ),
  },

  // {
  //   path: URL_PATHS.ADD_ON_MODULES,
  //   display: "Add On Modules",
  //   component: AddOnModules,
  //   icon: "bx bx-crown",
  //   showOnMenu: true,
  //   userHasAccess: true,
  //   showOnBottom: true,
  // },

  // COMMUNICATIONS
  {
    path: URL_PATHS.ADD_NOTIFICATION,
    component: NotificationForm,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.ADD_CUSTOM_EMAIL,
    component: CustomEmailForm,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.EDIT_COMMUNICATION,
    component: EditCommunication,
    showOnMenu: false,
    userHasAccess: true,
  },

  // CATEGORIES
  {
    path: URL_PATHS.MANAGE_CATEGORIES,
    component: Categories,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.CREATE_CATEGORY,
    component: CategoryForm,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.EDIT_CATEGORY,
    component: CategoryForm,
    showOnMenu: false,
    userHasAccess: true,
  },

  //EXPERIENCES
  {
    path: URL_PATHS.ADD_NEW_EXPERIENCE,
    component: ExperienceForm,
    showOnMenu: false,
    // userHasAccess: !checkClientConfig("vendor_id", 1),
    // userHasAccess: checkClientConfig("manage_events"),
  },
  {
    path: URL_PATHS.EDIT_EXPERIENCE,
    component: ExperienceForm,
    showOnMenu: false,
    // userHasAccess: !checkClientConfig("vendor_id", 1),
    // userHasAccess: checkClientConfig("manage_events"),
  },

  // CLIENTS
  {
    path: URL_PATHS.CLIENTS,
    component: Clients,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },
  {
    path: URL_PATHS.ADD_CLIENT,
    component: ClientForm,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },
  {
    path: URL_PATHS.EDIT_CLIENT,
    component: ClientForm,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },
  {
    path: URL_PATHS.CLIENT_FEATURES,
    component: ClientFeatures,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },

  // PLACES
  {
    path: URL_PATHS.ADD_PLACE,
    component: PlacesForm,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.EDIT_PLACE,
    component: PlacesForm,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.VIEW_SURVEYS,
    component: Surveys,
    showOnMenu: false,
    userHasAccess: true,
  },

  // DOMAINS
  {
    path: URL_PATHS.DOMAINS,
    component: Domains,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.CREATE_DOMAIN,
    component: Domain,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.EDIT_DOMAIN,
    component: Domain,
    showOnMenu: false,
    userHasAccess: true,
  },

  // PRODUCTS AND SUBSCRIPTIONS
  {
    path: URL_PATHS.PRODUCTS_AND_SUBSCRIPTIONS,
    component: ProductsAndSubscriptions,
    display: "Products & Subscriptions",
    icon: "bx bx-spreadsheet",
    showOnMenu:
      checkClientConfig(clientConfig, "products_orders_enabled") &&
      checkPermission("manage_products"),
    userHasAccess:
      checkClientConfig(clientConfig, "products_orders_enabled") &&
      checkPermission("manage_products"),
  },
  {
    path: URL_PATHS.ORDER_DETAILS,
    component: OrderDetails,
    showOnMenu: false,
    userHasAccess: true,
  },

  // BOOKINGS
  {
    path: URL_PATHS.CANCELLED_BOOKING,
    component: CancelledBookingScreen,
    showOnMenu: false,
    userHasAccess: true,
  },
  {
    path: URL_PATHS.SUCCESS_BOOKING,
    component: SuccessBookingScreen,
    showOnMenu: false,
    userHasAccess: true,
  },

  // SITE USERS
  {
    path: URL_PATHS.SITE_USERS,
    component: SiteUsers,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },

  // ADMIN ROLE MANAGEMENT
  // ROLES
  {
    path: URL_PATHS.ADMIN_ROLES_MANAGEMENT,
    component: AdminRoles,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },
  // PERMISSIONS
  {
    path: URL_PATHS.PERMISSIONS_MANAGEMENT,
    component: Permissions,
    showOnMenu: false,
    userHasAccess: userIsGodMode(),
  },

  // CODES
  {
    path: URL_PATHS.GENERATE_CODES,
    component: GenerateCodeScreen,
    showOnMenu: false,
    userHasAccess: isMpClient() && checkPermission("manage_invitebandz_codes"),
  },

  // ANALYTICS
  {
    path: URL_PATHS.EVENT_REPORTS,
    component: EventReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.POLL_REPORTS,
    component: PollReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.SURVEY_REPORTS,
    component: SurveyResports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.FORM_BUILDER_REPORTS,
    component: FormBuilderReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.QUESTIONNAIRE_REPORTS,
    component: QuestionnaireReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.TRIVIA_REPORTS,
    component: TriviaReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.POLL_LIST,
    component: PollList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.SURVEY_LIST,
    component: SurveyList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.FORM_BUILDER_LIST,
    component: FormBuilderList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.QUESTIONNAIRE_LIST,
    component: QuestionnaireList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.TRIVIA_LIST,
    component: triviaList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.EVENT_INFO_LIST,
    component: eventInfoList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.WEB_LINK_LIST,
    component: linkList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.WEB_LINK_REPORTS,
    component: Links,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.BOOKING_PAYMENT_REPORTS,
    component: bookingPayments,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.FORM_PAYMENT_REPORTS,
    component: formPayments,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.EVENT_INFO_REPORTS,
    component: EventInfoReport,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.BASIC_CONTENT_LIST,
    component: basicContentList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.BASIC_CONTENT_REPORTS,
    component: BasicContent,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.DOCUMENT_LIST,
    component: documentList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.DOCUMENT_REPORTS,
    component: Documents,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.COMMENT_BOARD_LIST,
    component: commentBoardList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.COMMENT_BOARD_REPORTS,
    component: CommentBoard,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.COUNTDOWN_CLOCK_LIST,
    component: countdownClockList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.COUNTDOWN_CLOCK_REPORTS,
    component: CountdownClock,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.MEDIA_GALLERY_LIST,
    component: mediaGalleryList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.MEDIA_GALLERY_REPORTS,
    component: MediaGallery,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.BOOKING_CALENDAR_REPORTS,
    component: Bookings,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.CAMERA_REPORTS,
    component: Camera,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.LEADERBOARD_REPORTS,
    component: Leaderboard,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.PRIVATE_MESSAGE_REPORTS,
    component: PrivateMessage,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.REFER_FRIEND_REPORTS,
    component: ReferFriend,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.ATTENDEE_LIST_REPORTS,
    component: AttendeeList,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.CALENDAR_REPORTS,
    component: Calendars,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.LIST_OF_LISTS,
    component: listOfLists,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.LIST_REPORTS,
    component: Lists,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.LIST_ITEM_REPORTS,
    component: listItem,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.SUB_CALENDAR_REPORTS,
    component: SubCalendarReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.USER_BOOKING_REPORTS,
    component: UserReports,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.BOOKING_REPORTS,
    component: bookingData,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.FLAGGED_CONTENT,
    component: FlaggedContent,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.NEWS_FEED,
    component: NewsFeed,
    display: "News Feed",
    icon: "bx bx-news",
    showOnMenu: checkClientConfig(clientConfig, "news_feed_enabled"),
    userHasAccess: checkClientConfig(clientConfig, "news_feed_enabled"),
  },

  // Route For inbox
  {
    path: URL_PATHS.INBOX_INB,
    component: Inbox,
    display: "Inbox",
    icon: "bx bx-message",
    showOnMenu: checkClientConfig(clientConfig, "web_inbox_enabled"),
    userHasAccess: checkClientConfig(clientConfig, "web_inbox_enabled"),
  },
  {
    path: URL_PATHS.COMMENT_BOARDS,
    showOnMenu: false,
    userHasAccess: true,
  },

  {
    path: URL_PATHS.AXISCARE,
    component: AxisCare,
    display: "AxisCare",
    icon: "bx bxl-redux",
    showOnMenu: checkClientConfig(
      clientConfig,
      "axis_care_integration_enabled"
    ),
    userHasAccess: checkClientConfig(
      clientConfig,
      "axis_care_integration_enabled"
    ),
  },

  // this route should be at the end of all other routes
  {
    path: "/",
    showOnMenu: false,
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
]

const authRoutes = [
  { path: URL_PATHS.LOGOUT, component: Logout },
  { path: URL_PATHS.LOGIN, component: Login },
  { path: URL_PATHS.FORGET_PWD, component: ForgetPwd },
  { path: URL_PATHS.RESET_PWD, component: ResetPwd },
  { path: URL_PATHS.TWO_FA, component: Two_FA },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
]

const orderRoutes = [
  { path: URL_PATHS.CHECKOUT_SUCCESS, component: OrderConfirmation },
  { path: URL_PATHS.IFO_SUBSCRIPTION, component: IfoOrderForm },
  { path: URL_PATHS.HARVARD_SUBSCRIPTION, component: harvard_orderForm },
  { path: URL_PATHS.DEFAULT_FORM_URL, component: default_form },
]

export { authRoutes, MENU_GROUPS, orderRoutes }
